/** DirectionalLight2D semantic rule: an inverted layer window. A directional light has no z test. */
import { ruleRegistry } from '../../../linter/RuleRegistry.js';
import { invertedRangeWindowMessage, LAYER_WINDOW } from '../lights/shared/invertedRangeWindow.js';
import { armEmits, groundedArm, reportArm } from '../../../linter/ruleArms.js';
const arms = {
    invertedLayerRange: groundedArm('directionallight2d-inverted-layer-range', {
        kind: 'engine-inert',
        at: 'renderer_viewport.cpp:681',
        unused: 'the inclusive layer test can never pass, so the light reaches no canvas',
    }),
};
function checkDirectionalLight2D(context) {
    const { node } = context;
    const message = invertedRangeWindowMessage('DirectionalLight2D', node.rawProperties, LAYER_WINDOW);
    const diagnostics = [];
    if (message)
        reportArm(diagnostics, arms.invertedLayerRange, node, message);
    return diagnostics;
}
const directionalLight2DValidationRule = {
    meta: {
        name: 'valid-directionallight2d-ranges',
        description: 'Validates that a DirectionalLight2D layer range window does not invert',
        category: 'validation',
        applicableNodeTypes: ['DirectionalLight2D'],
        emits: armEmits(arms),
    },
    check: checkDirectionalLight2D,
};
ruleRegistry.register(directionalLight2DValidationRule);
//# sourceMappingURL=linter.js.map